import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@app/core/services/api.service';
import { map } from 'rxjs/operators';
import { JwtService } from '@app/core/services/jwt.service';

export interface ProfileDataContext {
  participantId: string;
  firstName: string;
  middleName: string;
  lastName: string;
  gender: string;
  sdob: any;
  homephnum: string;
  workphnum: string;
  address1: string;
  address2: string;
  address3: string;
  state: string;
  zipCode: string;
}

@Injectable()
export class ProfileService {
  constructor(
    private apiService: ApiService,
    private jwtService: JwtService
  ) { }
  profileUpdate(context: ProfileDataContext): Observable<any> {
    let loggedInUser = this.jwtService.getLoggedInUser();
    var spDob = null;
    if (context.sdob != undefined && context.sdob != null) {
      spDob = context.sdob.year + '-' + context.sdob.month + '-' + context.sdob.day;
    }
    const data = {
      't2ParticipantId': context.participantId,
      'firstName': context.firstName,
      'secondInitial': context.middleName,
      'lastName': context.lastName,
      'gender': context.gender,
      'spouseDateOfBirth': spDob,
      'homeTelephoneNo': context.homephnum,
      'workTelephoneNo': context.workphnum,
      'addressLine1': context.address1,
      'addressLine2': context.address2,
      'addressLine3': context.address3,
      'stateCode': context.state,
      'zipCode': context.zipCode != null ? context.zipCode.replace(/-/g, "") : null,
      'registeredEmail': loggedInUser.email
    };
    return this.apiService.post('/profileUpdate', data)
      .pipe(
        map(
          res => {
            //console.log("response" + res);
            return res
          },
          err => {
            console.log("error response" + err);
          }
        )
      );
  }
}
